import { CALL_API } from 'redux-api-middleware'
export const LOAD_LINE_FORM_DETAIL_REQUEST = 'LOAD_LINE_FORM_DETAIL_REQUEST'
export const LOAD_LINE_FORM_DETAIL_SUCCESS = 'LOAD_LINE_FORM_DETAIL_SUCCESS'
export const LOAD_LINE_FORM_DETAIL_FAILURE = 'LOAD_LINE_FORM_DETAIL_FAILURE'
// import { replace } from 'react-router-redux'
import { token } from '../../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const loadLineFormDetail = (endpoint) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers,
        types: [
          LOAD_LINE_FORM_DETAIL_REQUEST,
          LOAD_LINE_FORM_DETAIL_SUCCESS,
          LOAD_LINE_FORM_DETAIL_FAILURE,
        ],
      },
    })
  }
}


// WEBPACK FOOTER //
// ./src/components/LineFormDetail/actions.js